<form [formGroup]="modbusRegisterForm" class="card mb-4">

  <div class="card-header">
    <div class="row align-items-center">
      <div class="col">
        <div class="form-group mb-0">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" translate>Register address</span>
            </div>
            <input name="address" type="number" [min]="REGISTER_ADDRESS_MIN" formControlName="address" class="form-control"
              [ngClass]="{'is-invalid': formControls.address.errors}"
              (focusout)="onUpdateAddress()">
            </div>
          </div>
          @if (formControls.address.errors) {
            <div class="invalid-feedback">
              <span translate>Register address required</span>
            </div>
          }
        </div>
        <div class="col-auto">
          <button aria-label="remove register" class="btn btn-outline-danger" title="Remove register" (click)="onRemoveRegister()">
            <span class="fa-solid fa-trash" aria-hidden="true"></span>
          </button>
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="row align-items-center mb-2">
        <div class="col">
          <span class="h5" translate>Signals</span>
        </div>
        <div class="col-auto">
          <button aria-label="add signal" class="btn btn-primary btn-sm" title="Add signal" (click)="onAddSignal()">
            <span class="fa-solid fa-plus" aria-hidden="true"></span>
            <span translate>Add signal</span>
          </button>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-3" translate><b>Data type</b></div>
        <div class="col-3" translate><b>Signal name</b></div>
        <div class="col-3" translate><b>Byte order</b></div>
        <div class="col" translate><b>Bitmask</b></div>
        <div class="col-auto text-right" translate><b>Actions</b></div>
      </div>

      @for (signal of register.signals; track signal) {
        <scitis-admin-gateway-modbus-register-signals
          [signal]="signal"
          [byteOrder]="byteOrder"
          (removeSignalChangeEvent)="onRemoveSignal($event)"
          (formIsValid)="onSignalFormIsValid($event)">
        </scitis-admin-gateway-modbus-register-signals>
      }
    </div>
  </form>